// TODO: test this file

import {
  type CanvasElement,
  type NavigationElementType,
  type SlotAlignment,
  type SlotIdOf,
} from '@blaze-runtime/engine-domain';

import { isElementType } from './element-type-guards';

/**
 * Used to get horizontal alignment in slot
 * Provides a default value
 */
export function getHorizontalAlignment(alignment?: SlotAlignment): SlotAlignment['horizontal'] {
  return alignment?.horizontal || 'left';
}

/**
 * Used to get vertical alignment in slot
 * Provides a default value
 */
export function getVerticalAlignment(alignment?: SlotAlignment): SlotAlignment['vertical'] {
  return alignment?.vertical || 'top';
}

export function getElementSlotsCount(element?: CanvasElement): number {
  return element?.slots?.ids ? element.slots.ids.length : 0;
}

export function getHostSlotIdOfNavigationElement(
  element?: CanvasElement,
): SlotIdOf<NavigationElementType> | undefined {
  if (isElementType(element, 'navContainer')) {
    return 'nsHostType:Header';
  }

  if (isElementType(element, 'navSidebar')) {
    return 'nsHostType:Sidebar';
  }

  if (isElementType(element, 'navBottombar')) {
    return 'nsHostType:Bottombar';
  }

  return undefined;
}
